import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const { FiMail, FiCheckCircle } = FiIcons;

const InputArea = ({ emailGated, onSubmitEmail, emailSubmitted }) => {
  const [email, setEmail] = useState('');

  const isValidEmail = (text) => {
    // Standard email validation regex and 254 character limit (RFC 3696)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(text.trim()) && text.trim().length <= 254;
  };

  const handleEmailSubmit = () => {
    if (isValidEmail(email)) {
      onSubmitEmail(email.trim());
    }
  };

  // If email has been submitted, show the final highlighted message
  if (emailSubmitted) {
    return (
      <div className="px-4 py-5 border-t border-gray-100 bg-white relative z-10 shadow-[0_-4px_20px_rgba(0,0,0,0.02)]">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="max-w-3xl mx-auto"
        >
          <div className="p-4 bg-[#fdf8f3] border-l-4 border-[#543e18] rounded-r-xl shadow-sm rounded-l-sm flex gap-3 items-start">
            <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-[#543e18] mt-0.5 flex-shrink-0" />
            <p className="text-[14.5px] text-[#543e18] leading-relaxed">
              <span className="font-semibold block mb-1">One of my humans will get in touch within 7 days.</span>
              For a quick response (within an hour), write to us:{' '}
              <a href="mailto:we@whatastory.agency" className="font-semibold underline decoration-[#c4a882] underline-offset-2 hover:text-[#3d2c0f] transition-colors">
                we@whatastory.agency
              </a>.
              <br />
              Or Fill up the contact form:{' '}
              <a href="https://whatastory.agency/contact-us" target="_blank" rel="noopener noreferrer" className="font-semibold underline decoration-[#c4a882] underline-offset-2 hover:text-[#3d2c0f] transition-colors">
                https://whatastory.agency/contact-us
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <AnimatePresence>
      {emailGated && (
        <motion.div
          initial={{ opacity: 0, y: 20, height: 0 }}
          animate={{ opacity: 1, y: 0, height: 'auto' }}
          exit={{ opacity: 0, y: 20, height: 0 }}
          className="px-4 py-4 border-t border-gray-100 bg-white overflow-hidden relative z-10 shadow-[0_-4px_20px_rgba(0,0,0,0.02)]"
        >
          <div className="max-w-3xl mx-auto flex flex-col gap-3">
            <div className="flex flex-col gap-3 p-4 bg-[#fdf8f3] border border-[#e8d9c4] rounded-xl shadow-sm">
              <div className="flex items-start gap-2">
                <p className="text-[14px] text-[#543e18] font-medium bg-[#f5ece0] px-3 py-2 rounded-md inline-block shadow-sm ring-1 ring-[#e8d9c4]">
                  ✨ Please provide your work email so one of our community experts can send you precise video recommendations directly to your inbox.
                </p>
              </div>
              <div className="flex gap-2 items-center mt-1">
                <div className="relative flex-1">
                  <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="name@company.com"
                    maxLength={254}
                    className="w-full bg-white border border-[#e8d9c4] outline-none text-[14px] pl-9 pr-3 py-2.5 rounded-lg focus:border-[#543e18] transition-colors shadow-sm"
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleEmailSubmit();
                      }
                    }}
                  />
                </div>
                <button
                  onClick={handleEmailSubmit}
                  disabled={!isValidEmail(email)}
                  className="px-5 py-2.5 bg-[#543e18] text-white text-[14px] font-medium rounded-lg disabled:opacity-50 transition-opacity hover:bg-[#3d2c0f]"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InputArea;